import { useMemo } from "react";
import strapped from "modules/Core/higher-order-components/strapped";
import subscriptionsFeed from "modules/membership/state/feed";
import AdminSyncUserSubscriptionPayments from "modules/admin/components/AdminSyncUserSubscriptionPayments";

const columns = [
    {
        key: "id",
        label: "ID",
    },
    {
        key: "subscriptionId",
        label: "Subscription ID",
    },
    {
        key: "user.email",
        label: "User Email",
    },
    {
        key: "user.id",
        label: "User ID",
    },
    {
        key: "stamps.activatedDate",
        label: "Activated",
    },
    {
        key: "tier",
        label: "Tier",
    },
    {
        key:'sync', 
        label: "Sync payments",
        render: (props) => <AdminSyncUserSubscriptionPayments userId={props?.user?.id} />
    }
]

export default strapped(subscriptionsFeed.FeedComponent, ({ userId }) => ({
    filters: useMemo(() => ({ userId }), [userId]),
    // feed: MOCK_DATA,
    columns,
    table: true,
}));